import * as React from "react";
import classNames from "classnames";
import CtaButton from "~/components/cta-button/cta-button";
import { HorizontalAlignmentType } from "~/types/alignment";
import Title from "~/components/title/title";
import ContentSection from "../content-section/content-section";

export interface TextCtaProps {
    richText?: string;
    title?: string;
    isTitleH1?: boolean;
    ctaLink?: string;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
    horizontalAlignContent?: HorizontalAlignmentType;
    className?: string;
    anchorId?: string;
    makeModuleWide?: boolean;
}

const TextCta: React.FC<TextCtaProps> = ({
    richText,
    title,
    isTitleH1,
    className,
    ctaLink,
    horizontalAlignContent,
    children,
    makeModuleWide ,
    ...props
}) => {
    const baseClass = "text-cta";
    const componentClasses = classNames(baseClass, className, {
        [`text-align-${horizontalAlignContent}`]: !!horizontalAlignContent
    });

    const innerComponentClasses = classNames(`${baseClass}__inner`, {
        [`${baseClass}__with-max-width`]: !makeModuleWide 
    });

    return (
        <ContentSection className={componentClasses} {...props}>
            <div className={innerComponentClasses}>
                {title && <Title title={title} isTitleH1={isTitleH1} />}
                {richText && (
                    <div className="content-rich-text" dangerouslySetInnerHTML={{ __html: richText }} />
                )}
                {ctaLink && <CtaButton className={`${baseClass}__btn`} link={ctaLink} isLarge />}
                {children}
            </div>
        </ContentSection>
    );
};

export default TextCta;
